import { principles, testimonials } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function About() {
  return (
    <section id="about" className="scroll-mt-16 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          index="08"
          eyebrow="About"
          title="关于看料网"
          desc="一个把『被折叠的部分翻出来』的深度内容媒体。我们相信，理解比围观更有价值。"
        />

        <div className="grid gap-6 lg:grid-cols-3">
          <div className="flex flex-col justify-between overflow-hidden rounded-lg border border-background-200 bg-background-950 p-6 md:p-7">
            <div>
              <span className="grid h-11 w-11 place-items-center rounded-md bg-primary-500 font-heading text-xl font-black text-background-50">
                料
              </span>
              <h3 className="mt-5 font-heading text-2xl font-black text-background-50">看料网</h3>
              <p className="mt-2 font-mono text-xs uppercase tracking-widest text-accent-300">Deeper than the surface</p>
              <p className="mt-4 text-sm leading-relaxed text-background-200/85">
                面向已吃透表象、想看更深一层的人。我们不做最快的快讯，只做经得起复查的结构化深度内容——
                内幕挖掘、真相梳理、独家线索与深层解析并行，把背后关系图谱拉出来给你看。
              </p>
            </div>
            <div className="mt-6 grid grid-cols-3 gap-2 border-t border-background-200/20 pt-5 text-center">
              {[
                { n: "公开", t: "信息来源" },
                { n: "严谨", t: "分级标注" },
                { n: "克制", t: "不煽情绪" },
              ].map((x) => (
                <div key={x.t}>
                  <p className="text-xs text-accent-300">{x.n}</p>
                  <p className="mt-0.5 text-[11px] text-background-300">{x.t}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4 lg:col-span-2">
            {principles.map((p) => (
              <div key={p.key} className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-md bg-accent-500 font-heading text-sm font-black text-background-950">
                  {p.key}
                </span>
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-950">{p.title}</h4>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure key={t.name} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex gap-0.5 text-accent-500" aria-label="五星评价">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
                <span className="grid h-7 w-7 place-items-center rounded-full bg-secondary-200 text-secondary-900">
                  <i className="ri-user-3-line" />
                </span>
                {t.name}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}